<template>
  <div class="card is-min-width-700" v-if ="ligneCommande">
    <header class="bandeau-modal card-header">
    </header>
    <div class="pdl-20px pdr-20px">
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('demandeLogistique.titleIntervention') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content pdl-0 pdr-0">
        <div class="mgb-20px">
          <span class="is-size-5 has-text-weight-bold has-text-link">
            {{ ligneCommande.produit.reference }}
          </span> -
          <span class="is-size-5">
            {{ligneCommande.libelle}}
          </span>
          <br/>
          <span class="has-text-default">
            {{ getPeriodeVendue(ligneCommande) }}
          </span>
          <div v-if="ligneCommande.datePlanifieeLogistiqueAffichage">
            {{ $t('editionCommande.logistique.posePlanification') }}
            {{ formatDate(ligneCommande.datePlanifieeLogistiqueAffichage) }}
          </div>
        </div>
        <div v-if="multiActionLogistique(ligneCommande)"
          class="has-text-weight-bold has-text-danger mgb-20px">
          {{ $t('demandeLogistique.messageMultiAction')}}
        </div>
        <div>
          <v-client-table
            :data="ligneCommande.demandesLogistique"
            :columns="columns"
            :options="options"
            class="vueTableFilterStyle">
             <template #datePlanification="props">
              {{ props.row.datePlanification | formatDate }}
            </template>
            <template #type="props">
              <span> {{ $t(getTypeDemandeLibelle(props.row.type)) }} </span>
            </template>
            <template #etat="props">
              <span> {{ $t(getEtatLibelle(props.row.etat)) }} </span>
            </template>
            <template #source="props">
              <span> {{ $t(getSourceLibelle(props.row.source)) }} </span>
            </template>
            <template #typeOtId="props">
              <span> {{ getTypeOt(props.row.typeOtId) }} </span>
            </template>
            <template #demandeurId="props">
              {{ getUser(props.row.demandeurId) }}
            </template>
            <template #ordreRealisation="props">
              <div class="level-right">
                {{ props.row.ordreRealisation }}
              </div>
            </template>
            <template #otTechniqueId="props">
              <router-link-blank
                v-if="props.row.otTechnique"
                :to="{ name: 'c.logistique.ordre_travail-tech',
                      params: { id: props.row.otTechnique.id } }"
                :message="props.row.otTechnique.code"
                typeIcon="is-primary" sizeIcon="is-small">
              </router-link-blank>
            </template>
            <template #delete="props" >
              <a @click=" popupSupp(props.row)">
                <b-icon
                  icon="delete-forever"
                  type="is-danger"
                  :class="{ 'text-access-no-permission'
                  : !checkPermissions(permDemande.supprimer) || props.row.estDansOtAffichage}">
                </b-icon>
              </a>
            </template>
            <template #update="props" >
              <a @click=" popupUpdate(props.row)">
                <b-icon
                  icon="pencil-box-outline"
                  type="is-success"
                  :class="{ 'text-access-no-permission'
                  : !checkPermissions(permDemande.maj) || props.row.estDansOtAffichage}">
                </b-icon>
              </a>
            </template>
          </v-client-table>
        </div>
        <footer>
          <b-field>
            <div class="boutonAction center">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.close')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="this.$t('demandeLogistique.popUpSuppression.title')"
        :messDescription="this.$t('demandeLogistique.popUpSuppression.message')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteDemande"/>
    </b-modal>
    <b-modal v-model="popUpModification" has-modal-card class="modal">
        <pop-up-modifier
          @refreshList="refreshList"
          :devisCommandeIdFromLigne="devisCommandeIdFromLigne"
          :demandeLogistique="ligneAModifier">
        </pop-up-modifier>
    </b-modal>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { deleteDemandeLogistique } from '@/api/logistique/demandeLogistique/index';
import { DEMANDE } from '@/configuration/logistique/permissionsLogistiqueConf';
import messageErreur from '@/services/general/messageErreur';
import formatDate from '@/services/general/formatDate';
import messageSucces from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import multiActionLogistiqueGetter from '@/services/logistique/demandeLogistique/multiActionLogistiqueGetter';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import {
  TYPE_INTERVENTION,
  ETAT_DEMANDE_INTERVENTION,
  SOURCE_INTERVENTION,
} from '@/configuration/logistique/intervention/interventionConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import popUpModifier from './p_editionDemande';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'p_demandeLogistiques',
  props: {
    ligneCommande: {
      type: Object,
      required: true,
    },
    devisCommandeId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      demandeASupp: null,
      popUpSuppression: false,
      creationDemandeParametre: {
        datePlanification: moment().toDate(),
        actionLogistique: '',
      },
      permDemande: DEMANDE,
      popUpModification: false,
      ligneAModifier: null,
    };
  },
  components: {
    popUpPrevention,
    popUpModifier,
    routerLinkBlank,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    typesOT() {
      return this.parametre(PARAMETRES_KEYS.typeOt);
    },
    columns() {
      const cols = [
        'datePlanification',
        'actionLogistique',
        'type',
        'typeOtId',
        'etat',
        'demandeurId',
        'source',
        'ordreRealisation',
        'otTechniqueId',
        'update',
        'delete',
      ];
      return cols;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          actionLogistique: this.$i18n.t('demandeLogistique.table.actionLogistique'),
          datePlanification: this.$i18n.t('demandeLogistique.table.datePlanification'),
          type: this.$i18n.t('demandeLogistique.table.typeDemande'),
          typeOtId: this.$i18n.t('demandeLogistique.table.typeOt'),
          etat: this.$i18n.t('demandeLogistique.table.etat'),
          demandeurId: this.$i18n.t('demandeLogistique.table.demandeur'),
          source: this.$i18n.t('demandeLogistique.table.source'),
          ordreRealisation: this.$i18n.t('demandeLogistique.table.ordreRealisation'),
          otTechniqueId: this.$i18n.t('demandeLogistique.table.otTechniqueId'),
          delete: '',
          update: '',
        },
        sortable: [
          'datePlanification',
          'actionLogistique',
          'ordreRealisation',
        ],
        texts: texts,
        filterable: ['datePlanification', 'actionLogistique', 'type', 'typeOtId', 'etat', 'source', 'ordreRealisation'],
        filterByColumn: true,
        listColumns: {
          typeOtId: this.typesOT.map(t => ({
            id: t.id,
            text: t.libelle,
          })),
          type: TYPE_INTERVENTION.map(t => ({
            id: t.key,
            text: this.$t(t.libelle),
          })),
          etat: ETAT_DEMANDE_INTERVENTION.map(e => ({
            id: e.key,
            text: this.$t(e.libelle),
          })),
          source: SOURCE_INTERVENTION.map(s => ({
            id: s.key,
            text: this.$t(s.libelle),
          })),
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        columnsClasses: {
          datePlanification: 'colonneWith180',
          typeOtId: 'colonneWith180',
          delete: 'colonneSelected-35 ',
          update: 'colonneSelected-35 ',
          ordreRealisation: 'colonneSelected-35',
        },
      };
    },
    devisCommandeIdFromLigne() {
      return this.ligneCommande?.devisCommandeId ?? this.devisCommandeId;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
    }),
    getTypeDemandeLibelle(value) {
      return TYPE_INTERVENTION
        .find(type => type.key === value)?.libelle ?? '';
    },
    getEtatLibelle(value) {
      return ETAT_DEMANDE_INTERVENTION
        .find(el => el.key === value)?.libelle ?? '';
    },
    getSourceLibelle(value) {
      return SOURCE_INTERVENTION
        .find(el => el.key === value)?.libelle ?? '';
    },
    getTypeOt(id) {
      return this.typesOT.find(t => t.id === id)?.libelle ?? '';
    },
    getUser(userId) {
      const userFind = this.parametre(PARAMETRES_KEYS.utilisateur).find((user) => {
        return user.id === userId;
      });
      return userFind ? userFind.decorator.nomPrenom : '';
    },
    refreshList(demande) {
      const index = this.ligneCommande.demandesLogistique.findIndex(d => d.id === demande.id);
      if (index > -1) this.ligneCommande.demandesLogistique.splice(index, 1, demande);
      this.tri();
    },
    formatDate(date) {
      return formatDate(date);
    },
    multiActionLogistique(ligne) {
      return multiActionLogistiqueGetter(ligne);
    },
    getPeriodeVendue(ligne) {
      if (ligne.dateDebut && ligne.dateFin) {
        const result = {
          dateDebut: formatDate(ligne.dateDebut),
          dateFin: formatDate(ligne.dateFin),
        };
        if (ligne.ligneReseau?.anneeSemaine) {
          result.semaine = ligne.ligneReseau.anneeSemaine.toString().substring(4, 6);
          return this.$t('detail.article.dateTempo', result);
        }
        return this.$t('detail.article.date', result);
      }
      return this.$t('dateDevis.pasDate');
    },
    popupSupp(demande) {
      if (!this.checkPermissions(this.permDemande.supprimer) || demande.estDansOtAffichage) {
        return;
      }
      this.demandeASupp = demande;
      this.popUpSuppression = true;
    },
    popupUpdate(demande) {
      if (!this.checkPermissions(this.permDemande.maj) || demande.estDansOtAffichage) {
        return;
      }
      this.ligneAModifier = {
        ...cloneDeep(demande),
        ligneReseau: this.ligneCommande.ligneReseau,
        produitId: this.ligneCommande.produitId,
        demandeLogistiqueSelProduit: demande.demandeLogistiqueSelProduit,
        dateDebut: this.ligneCommande?.dateDebut,
        dateFin: this.ligneCommande?.dateFin,
        ligneCommandeid: demande?.ligneCommandeId,
      };
      this.ligneAModifier.typeProduit = this.ligneCommande.typeProduit;
      this.popUpModification = true;
    },
    async deleteDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteDemandeLogistique(this.demandeASupp.id);
        const indexDemandeASupp = this.ligneCommande.demandesLogistique.findIndex(d => {
          return this.demandeASupp.id === d.id;
        });
        if (indexDemandeASupp > -1) {
          this.ligneCommande.demandesLogistique.splice(indexDemandeASupp, 1);
        }
        this.demandeASupp = null;
        this.popUpSuppression = false;
        loadingComponent.close();
        messageSucces(this.$i18n.t('demandeLogistique.popUpSuppression.success'));
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    tri() {
      this.ligneCommande.demandesLogistique = this.ligneCommande.demandesLogistique.sort((a, b) => {
        return new Date(a.datePlanification) - new Date(b.datePlanification);
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      this.tri();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
